import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export const LeaderPicker = ({ group, dis, onSaved }) => {
  const [emps, setEmps] = useState([]);
  const [sel, setSel] = useState(group.leader_ids || []);
  useEffect(() => { setSel(group.leader_ids || []); }, [group.id, group.leader_ids]);
  useEffect(() => { api.get("/leave/colleagues").then(({ data }) => setEmps(data)).catch(() => {}); }, []);
  const toggle = async (id) => {
    if (dis) return;
    const next = sel.includes(id) ? sel.filter((x) => x !== id) : [...sel, id];
    try { await api.put(`/office-groups/${group.id}/leaders`, { leader_ids: next }); setSel(next); onSaved(); toast.success("Kepala tim disimpan"); }
    catch (e) { toast.error(e.response?.data?.detail || "Gagal menyimpan"); }
  };
  return (
    <div className="mb-5 p-3 rounded-lg bg-slate-50" data-testid="leader-picker">
      <div className="text-xs font-mono text-slate-500 mb-2">KEPALA TIM {group.name.toUpperCase()} — boleh mengatur giliran Sabtu–Minggu anggota grup ini & menerima pengingat Jumat</div>
      <div className="flex flex-wrap gap-2">
        {emps.map((e) => (
          <button key={e.id} type="button" disabled={dis} data-testid={`leader-${e.id}`} onClick={() => toggle(e.id)}
            className={`text-xs px-2.5 py-1 rounded-full border ${sel.includes(e.id) ? "bg-slate-900 text-white border-slate-900" : "border-slate-300 bg-white"}`}>{e.name}</button>
        ))}
      </div>
    </div>
  );
};
